import React from "react";
import Row from "../common/Row";
import TextInput from "../common/TextInput";
import PropTypes from "prop-types";

const ScoreSubFieldset = (props) => {
    const { omschrijving, score, wegingsfactor, gewogenScore, disabled, isBold, key } = props;
    return (
        <Row>
            <TextInput
                label="omschrijving"
                name="omschrijving"
                disabled={disabled}
                value={omschrijving}
                size={6}
            />
            <TextInput
                label="score"
                name="score"
                disabled={disabled}
                value={score}
                size={2}
            />
            <TextInput
                label="wegingsfactor"
                name="wegingsfactor"
                disabled={disabled}
                value={wegingsfactor}
                size={2}
            />
            <TextInput
                label="gewogen Score"
                name="gewogenScore"
                disabled={disabled}
                value={gewogenScore}
                size={2}
            />
        </Row>
    );
};

ScoreSubFieldset.propTypes = {
    disabled: PropTypes.bool,
    omschrijving: PropTypes.string,
    wegingsfactor: PropTypes.string,
    score: PropTypes.string,
    gewogenScore: PropTypes.string,
    isBold: PropTypes.bool,
    key: PropTypes.number
};

export default ScoreSubFieldset;